import { render, staticRenderFns } from "./RoomTable.vue?vue&type=template&id=35e6bc1f&scoped=true&lang=pug"
import script from "./RoomTable.vue?vue&type=script&lang=ts"
export * from "./RoomTable.vue?vue&type=script&lang=ts"
import style0 from "./RoomTable.vue?vue&type=style&index=0&id=35e6bc1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e6bc1f",
  null
  
)

export default component.exports